import { __awaiter } from "tslib";
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import waitForOptimizely, { getOptimizelyValue } from 'pathfinder/utils/waitForOptimizely';
import getDiscussionsCategoriesData from './modules/DiscoveryModuleRailDiscussionsActivity/helpers/getDiscussionCategoriesData';
import renderOnRightRail from './modules/DiscoveryModuleRailDiscussionsActivity/helpers/renderOnRightRail';
import { RAIL_DISCUSSIONS_ACTIVITY } from './modules/DiscoveryModuleRailDiscussionsActivity/optimizely';
export const getDiscoveryModuleRailDiscussionsActivityMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const moduleProps = buildModuleProps(moduleConfig, {});
    const { log } = moduleProps;
    // override values if foced
    const defaultValues = moduleConfig.internalState.forced
        ? {
            sectionTitle: 'Discussions Activity',
        }
        : {
        /* no default values for non-forced module */
        };
    try {
        yield waitForOptimizely();
        // read values from optimizely (with fallback)
        moduleProps.sectionTitle = getOptimizelyValue(RAIL_DISCUSSIONS_ACTIVITY.SECTION_TITLE, defaultValues.sectionTitle);
        // validate values from Optmizely
        if (!moduleProps.sectionTitle) {
            log.debug('Missing values from Optimizely', moduleProps);
            // fail silenty if values are missing
            return null;
        }
        else {
            log.debug('Successfully read values from Optimizely', moduleProps);
        }
        const categories = yield getDiscussionsCategoriesData();
        // Do not show Discussions Activity module unless there is at least one custom category (aside from General).
        if (categories.length < 2) {
            log.debug('No discussion data to show');
            return null;
        }
        moduleProps.categories = categories;
        const render = () => {
            renderOnRightRail(moduleConfig, moduleProps);
            return;
        };
        return {
            render,
        };
    }
    catch (error) {
        log.debug('DiscoveryModuleRailDiscussionsActivity error', error);
    }
    return null;
});
